import CreditCardPremiumIcon from 'assets/credit_card_premium_icon.svg?react';
import HistoryPremiumIcon from 'assets/history_premium_icon.svg?react';
import ShieldPremiumIcon from 'assets/shield_premium_icon.svg?react';
import styled from 'styled-components';

const PaymentInfoSection: React.FC = () => {
  return (
    <InfoSection>
      <InfoRow>
        <IconWrapper>
          <ShieldPremiumIcon />
        </IconWrapper>
        <InfoTitle>EroPlay.ai won’t access your payment data.</InfoTitle>
      </InfoRow>
      <InfoRow>
        <IconWrapper>
          <HistoryPremiumIcon />
        </IconWrapper>
        <InfoTitle>No adult transaction on your statement.</InfoTitle>
      </InfoRow>
      <InfoRow>
        <IconWrapper>
          <CreditCardPremiumIcon />
        </IconWrapper>
        <InfoTitle>Google Pay, Apple Pay, VISA, MasterCard.</InfoTitle>
      </InfoRow>
    </InfoSection>
  );
};

export default PaymentInfoSection;

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 26px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }

  @media (max-width: 380px) {
    margin-bottom: 12px;
  }
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const InfoRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const InfoTitle = styled.span`
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  color: #FFFFFF;

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 18px;
  }
`;
